<table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">{{ 'patient.patient-number' | translate }}</th>
      <th scope="col">{{ 'patient.external-id' | translate }}</th>
      <th scope="col">{{ 'patient.first-name' | translate }}</th>
      <th scope="col">{{ 'patient.middle-name' | translate }}</th>
      <th scope="col">{{ 'patient.last-name' | translate }}</th>
      <th scope="col">{{ 'patient.date-of-birth' | translate }}</th>
      <th scope="col">{{ 'common.city' | translate }}</th>
      <th scope="col">{{ 'patient.mobile' | translate }}</th>
      <th scope="col">{{ 'common.email' | translate }}</th>
    </tr>
  </thead>
  <tbody class="align-middle">
    @for (patient of patients(); track patient.id) {
      <tr
        (click)="onClickTableRow(patient.id)"
        (keydown.enter)="onClickTableRow(patient.id)"
        (keydown.space)="onClickTableRow(patient.id)"
        class="cursor-pointer"
        tabindex="0"
      >
        <td>{{ patient.patient_number }}</td>
        <td>{{ patient.external_id }}</td>
        <td>{{ patient.first_name }}</td>
        <td>{{ patient.middle_name }}</td>
        <td>{{ patient.last_name }}</td>
        <td>{{ patient.date_of_birth | localDateFormat }}</td>
        <td>{{ patient.city }}</td>
        <td>{{ patient.mobile }}</td>
        <td>{{ patient.email }}</td>
      </tr>
    }
  </tbody>
</table>
